export const RESET_TARGET = "RESET_TARGET";

export const CREATE_MONTHLY_TARGET_START = "CREATE_MONTHLY_TARGET_START"
export const CREATE_MONTHLY_TARGET_SUCCESS ="CREATE_MONTHLY_TARGET_SUCCESS"
export const CREATE_MONTHLY_TARGET_FAIL = "CREATE_MONTHLY_TARGET_FAIL"

export const GET_MONTHLY_TARGET_START = "GET_MONTHLY_TARGET_START"
export const GET_MONTHLY_TARGET_SUCCESS ="GET_MONTHLY_TARGET_SUCCESS"
export const GET_MONTHLY_TARGET_FAIL = "GET_MONTHLY_TARGET_FAIL"

export const UPDATE_MONTHLY_TARGET_START = "UPDATE_MONTHLY_TARGET_START"
export const UPDATE_MONTHLY_TARGET_SUCCESS ="UPDATE_MONTHLY_TARGET_SUCCESS"
export const UPDATE_MONTHLY_TARGET_FAIL = "UPDATE_MONTHLY_TARGET_FAIL"

export const CREATE_LOB_TARGET_START = "CREATE_LOB_TARGET_START"
export const CREATE_LOB_TARGET_SUCCESS ="CREATE_LOB_TARGET_SUCCESS"
export const CREATE_LOB_TARGET_FAIL = "CREATE_LOB_TARGET_FAIL"

export const GET_LOB_TARGET_START = "GET_LOB_TARGET_START"
export const GET_LOB_TARGET_SUCCESS ="GET_LOB_TARGET_SUCCESS"
export const GET_LOB_TARGET_FAIL = "GET_LOB_TARGET_FAIL"

export const UPDATE_LOB_TARGET_START = "UPDATE_LOB_TARGET_START"
export const UPDATE_LOB_TARGET_SUCCESS ="UPDATE_LOB_TARGET_SUCCESS"
export const UPDATE_LOB_TARGET_FAIL = "UPDATE_LOB_TARGET_FAIL"


export const CREATE_COMP_TARGET_START = "CREATE_COMP_TARGET_START"
export const CREATE_COMP_TARGET_SUCCESS ="CREATE_COMP_TARGET_SUCCESS"
export const CREATE_COMP_TARGET_FAIL = "CREATE_COMP_TARGET_FAIL"

export const GET_COMP_TARGET_START = "GET_COMP_TARGET_START"
export const GET_COMP_TARGET_SUCCESS ="GET_COMP_TARGET_SUCCESS"
export const GET_COMP_TARGET_FAIL = "GET_COMP_TARGET_FAIL"

export const UPDATE_COMP_TARGET_START = "UPDATE_COMP_TARGET_START"
export const UPDATE_COMP_TARGET_SUCCESS ="UPDATE_COMP_TARGET_SUCCESS"
export const UPDATE_COMP_TARGET_FAIL = "UPDATE_COMP_TARGET_FAIL"


export const GET_EMP_TARGET_START = "GET_EMP_TARGET_START"
export const GET_EMP_TARGET_SUCCESS = "GET_EMP_TARGET_SUCCESS"
export const GET_EMP_TARGET_FAIL = "GET_EMP_TARGET_FAIL"


export const CREATE_YEARLY_TARGET_START = "CREATE_YEARLY_TARGET_START"
export const CREATE_YEARLY_TARGET_SUCCESS ="CREATE_YEARLY_TARGET_SUCCESS"
export const CREATE_YEARLY_TARGET_FAIL = "CREATE_YEARLY_TARGET_FAIL"

export const GET_YEARLY_TARGET_START = "GET_YEARLY_TARGET_START"
export const GET_YEARLY_TARGET_SUCCESS ="GET_YEARLY_TARGET_SUCCESS"
export const GET_YEARLY_TARGET_FAIL = "GET_YEARLY_TARGET_FAIL"

export const UPDATE_YEARLY_TARGET_START = "UPDATE_YEARLY_TARGET_START"
export const UPDATE_YEARLY_TARGET_SUCCESS ="UPDATE_YEARLY_TARGET_SUCCESS"
export const UPDATE_YEARLY_TARGET_FAIL = "UPDATE_YEARLY_TARGET_FAIL"

export const GET_COM_MONTHLY_START = "GET_COM_MONTHLY_START"
export const GET_COM_MONTHLY_FAIL =  "GET_COM_MONTHLY_FAIL"
export const GET_COM_MONTHLY_SUCCESS = "GET_COM_MONTHLY_SUCCESS"

export const GET_COM_YEARLY_START = "GET_COM_YEARLY_START"
export const GET_COM_YEARLY_FAIL =  "GET_COM_YEARLY_FAIL"
export const GET_COM_YEARLY_SUCCESS = "GET_COM_YEARLY_SUCCESS"

export const GET_LOB_MONTHLY_START = "GET_LOB_MONTHLY_START"
export const GET_LOB_MONTHLY_SUCCESS = "GET_LOB_MONTHLY_SUCCESS"
export const GET_LOB_MONTHLY_FAIL = "GET_LOB_MONTHLY_FAIL"

export const GET_LOB_YEARLY_START = "GET_LOB_YEARLY_START"
export const GET_LOB_YEARLY_SUCCESS = "GET_LOB_YEARLY_SUCCESS"
export const GET_LOB_YEARLY_FAIL = "GET_LOB_YEARLY_FAIL"

export const GET_MONTHLY_CHART_START = "GET_MONTHLY_CHART_START"
export const GET_MONTHLY_CHART_SUCCESS = "GET_MONTHLY_CHART_SUCCESS"
export const GET_MONTHLY_CHART_FAIL = "GET_MONTHLY_CHART_FAIL"


export const GET_YEARLY_CHART_START = "GET_YEARLY_CHART_START"
export const GET_YEARLY_CHART_FAIL = "GET_YEARLY_CHART_FAIL"
export const GET_YEARLY_CHART_SUCCESS = "GET_YEARLY_CHART_SUCCESS"


export const RESET_TARGET_STATES = "RESET_TARGET_STATES";